import React from "react";
import styled from "styled-components";
import _ from "lodash";
import { Row, Col, Typography, Checkbox, Radio } from "antd";
import { Controller } from "react-hook-form";

import Editor from "rich-markdown-editor";

import { TInput } from "components/form/Field/TInput";
import { InputContainer, StyledDivider, StyledTitle } from "pages/jobs/add";
import JobTypeRadio from "components/job/add/form/jobTypeRadio";
import ClientSelect from "components/job/add/form/clientSelect";
import OtherInput from "components/job/add/form/otherInput";
import FinishingCheckbox from "components/job/add/form/finishingCheckbox";
import BindingCheckbox from "components/job/add/form/bindingCheckbox";
import CoverSection from "components/job/add/form/coverSection";
import ContentSection from "components/job/add/form/contentSection";

const { Text } = Typography;

const AddOrEditJobForm = (props) => {
  const {
    editJob,
    control,
    errors,
    getValues,
    setValue,
    trigger,
    watch,
    reset,
    jobTypeData,
    jobTypeStatus,
    finishingData,
    finishingStatus,
    bindingData,
    bindingStatus,
    setFinishingModalVisible,
    setBindingModalVisible,
    setPaperModalVisible,
    setAddPaperGrammageFrom,
    watchBindings,
    coverFields,
    contentFields,
    bookSizeUnit,
    setBookSizeUnit,
  } = props;

  return (
    <>
      {/* Job Information Container */}
      <FormContainerRow>
        <Col span={24}>
          <Row gutter={2} align="space-between" justify="middle">
            <Col span={6}>
              <StyledText>Job Information</StyledText>
            </Col>
            <Col span={6}>
              <UrgentContainer>
                <Controller
                  name="general.urgent"
                  defaultValue={watch("general.urgent")}
                  control={control}
                  render={() => (
                    <Checkbox
                      defaultChecked={watch("general.urgent")}
                      checked={watch("general.urgent")}
                      onChange={(e) =>
                        setValue("general.urgent", e.target.checked, {
                          shouldDirty: true,
                        })
                      }
                    />
                  )}
                />
                <Text className="title">Urgent</Text>
              </UrgentContainer>
            </Col>
          </Row>
          <StyledDivider />
        </Col>

        <Col span={24}>
          <Row gutter={16}>
            <Col xs={12}>
              <TInput
                label="Name"
                errors={errors}
                name="name"
                defaultValue={getValues("name")}
                placeholder="Job name"
                propsInput={{
                  control: control,
                }}
              />
            </Col>
            {/*Pages Input Field*/}
            <Col xs={6}>
              <InputContainer>
                <StyledTitle>Pages</StyledTitle>
                <TInput
                  errors={errors}
                  defaultValue={getValues("general.pages")}
                  name="general.pages"
                  placeholder="XXX"
                  propsInput={{
                    control: control,
                  }}
                  suffix={<StyledSuffix>M/S</StyledSuffix>}
                />
              </InputContainer>
            </Col>
            {/* Orientation Radio */}
            <Col xs={6}>
              <InputContainer>
                <StyledTitle>Orientation</StyledTitle>
                <Controller
                  control={control}
                  name="general.orientation"
                  render={() => {
                    return (
                      <Radio.Group
                        value={watch("general.orientation")}
                        optionType="button"
                        defaultValue={watch("general.orientation")}
                        size="medium"
                        optionType="button"
                        onChange={(e) => {
                          setValue("general.orientation", e.target.value, {
                            shouldDirty: true,
                          });
                          trigger("general.orientation");
                        }}
                        error={errors && _.get(errors, "general.orientation")}
                      >
                        {["Portrait", "Landscape"].map((option, index) => (
                          <Radio.Button value={option} key={`option-${index}`}>
                            {option}
                          </Radio.Button>
                        ))}
                      </Radio.Group>
                    );
                  }}
                />
              </InputContainer>
              {props.errors && _.get(props.errors, "general.orientation") && (
                <>
                  <StyledError>
                    <p>
                      {props.errors &&
                        _.get(props.errors, "general.orientation.message")}
                    </p>
                  </StyledError>
                </>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <JobTypeRadio
            control={control}
            setValue={setValue}
            trigger={trigger}
            jobTypeStatus={jobTypeStatus}
            jobTypeData={jobTypeData}
            joiErrors={errors}
            watch={watch}
            getValues={getValues}
            editMode={editJob ? true : false}
          />
        </Col>

        {/* Client quantity size delivery date Row */}
        <Col span={24}>
          <Row gutter={2}>
            <Col span={8}>
              <ClientSelect
                control={control}
                setValue={setValue}
                errors={errors}
                trigger={trigger}
              />
            </Col>
            <OtherInput
              control={control}
              setValue={setValue}
              errors={errors}
              trigger={trigger}
              watch={watch}
              getValues={getValues}
              bookSizeUnit={bookSizeUnit}
              setBookSizeUnit={setBookSizeUnit}
            />
          </Row>
        </Col>
        {/* End Client quantity size delivery date Row */}
        {/* Remarks Text Area*/}
        <Col xs={24}>
          <InputContainer>
            <StyledTitle>Remarks</StyledTitle>

            <StyledRemarksContainer>
              <Controller
                name="remarks"
                control={control}
                defaultValue={watch("remarks") || ""}
                render={({ onChange, onBlur, value }) => {
                  return (
                    <Editor
                      key={watch("name")}
                      defaultValue={watch("remarks") || ""}
                      placeholder="Write any instructions regarding this order"
                      onChange={(value) => {
                        setValue("remarks", value());
                        // return onChange(remarks());
                      }}
                    />
                  );
                }}
              />
            </StyledRemarksContainer>
          </InputContainer>
        </Col>
      </FormContainerRow>
      {/* End Job Information Container */}
      {/* Job Cover and Content Container */}
      <FormContainerRow gutter={2}>
        <Col span={24}>
          <Row gutter={2} align="space-between" justify="middle">
            <Col span={6}>
              <StyledText>Job Details</StyledText>
            </Col>
          </Row>
          <StyledDivider />
        </Col>
        <Col xs={24} lg={12}>
          <Row>
            <Col xs={24}>
              <FinishingCheckbox
                setValue={setValue}
                control={control}
                errors={errors}
                trigger={trigger}
                data={finishingData}
                status={finishingStatus}
                setFinishingModalVisible={setFinishingModalVisible}
              />
            </Col>
            <Col xs={24}>
              <BindingCheckbox
                control={control}
                setValue={setValue}
                errors={errors}
                trigger={trigger}
                data={bindingData}
                status={bindingStatus}
                setBindingModalVisible={setBindingModalVisible}
                watchBindings={watchBindings}
                watch={watch}
                editMode={editJob ? true : false}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={24} lg={12} style={{ paddingRight: "10px" }}>
          <Row>
            <Col xs={24}>
              <CoverSection
                control={control}
                setValue={setValue}
                errors={errors}
                trigger={trigger}
                coverFields={coverFields}
                getValues={getValues}
                reset={reset}
                watch={watch}
                setPaperModalVisible={setPaperModalVisible}
                setAddPaperGrammageFrom={setAddPaperGrammageFrom}
              />
            </Col>
            <Col xs={24}>
              <ContentSection
                control={control}
                setValue={setValue}
                errors={errors}
                trigger={trigger}
                contentFields={contentFields}
                getValues={getValues}
                reset={reset}
                watch={watch}
                setPaperModalVisible={setPaperModalVisible}
                setAddPaperGrammageFrom={setAddPaperGrammageFrom}
              />
            </Col>
          </Row>
        </Col>
      </FormContainerRow>
      {/* End Job Cover and Content Container */}
    </>
  );
};

const StyledText = styled(Text)`
  font-weight: 500;
  font-size: 1.1rem;
`;

const FormContainerRow = styled(Row)`
  margin: ${(props) => props.theme.spacing[2]} 0;
  background: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacing[8]};
  padding: 1px solid ${(props) => props.theme.colors.green[1]};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
`;

const UrgentContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  .title {
    font-weight: 600;
    margin-left: ${(props) => props.theme.spacing[2]};
  }
`;

const StyledSuffix = styled.p`
  color: ${(props) => props.theme.colors.grey[500]};
  text-transform: uppercase;
  font-size: ${(props) => props.theme.fontSize["xs"]};
  margin: 0;
`;

const StyledRemarksContainer = styled.div`
  padding: ${(props) => props.theme.spacing[2]};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  transition: all ease-in 0.3s;

  :hover,
  :active {
    border-color: ${(props) => props.theme.colors.primary};
  }

  .ProseMirror {
    .block-menu-trigger {
      left: -38px;
      color: ${(props) => props.theme.colors.grey[400]};
    }

    h1,
    h2 {
      ::before {
        left: -30px;
        line-height: 2em;
      }
    }
  }
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

export default AddOrEditJobForm;
